<template>
	<div class="loader-big">
		<div class="loader-big__overlay"></div>
		<div class="loader">
			<img src="@/assets/images/eretz-pulsing.gif" alt="loader">
		</div>
	</div>
</template>

<script>

export default {
	props: {},
	data () {
		return {
		};
	}
};
</script>
<style lang="scss" scoped>
.loader-big {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
    bottom: 0;
	width: 100%;
	height: auto;
	z-index: 9999999;

	.loader-big__overlay {
		&:after {
			content: "";
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background-color: rgba(255, 255, 255, 0.9);
			transition: .5s cubic-bezier(.77, 0, .18, 1);
			transition-delay: .8s;
		}

		&:after {
			right: 0;
		}
	}
}

.loader {
	position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
	display: flex;
	justify-content: center;
	align-items: center;

	@include mq($sm) {
		width: 60px;
		height: 60px;
	}
}
</style>
